
const themeDefaults = {
    fonts_url:       false,
    body_font:       'basic-sans',
    heading_font:    'basic-sans',
    deco_font:       'natalya',
    
    body_color:      '#183029',
    
    app_background:  '#ffffff',
    menu_background: '#183029',

    primary_color:   '#183029',
    primary_color_highlight: '#315148',
    primary_color_mid: '#4D5853',
    primary_color_light: '#A1A5A2',
    
    secondary_color: '#ADCAB8',
    secondary_color_mid: '#C4D9CB',
    secondary_color_light: '#E4EDE7',
    
    accent_color:    '#F89C6B',
    accent2_color:   '#804120',

    sold_color:      '#e17676b0',

    gold_gradient:   'linear-gradient(94deg, #A7552E -2%, #F89C6B 50%, #804120 105%)',
};

export function createTheme(options = {}) { 
    return { ...themeDefaults, ...options };
}
